import { ContentHeaderButton } from "../../contentHeaderButton";
import { IndorImages, getIndorImageSrc } from "../../../../features";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../../../stateManagement/hooks/redux";
import { controlHighContrastModeButton, controlMapSettingsButton, controlPrintButton } from "./widgetsFunctions";

const highContrastModeButtonIconSrc = require('../../../../assets/images/icons/black_and_white_map_icon.png')

const mapSettingsButtonIconSrc = getIndorImageSrc(IndorImages.MapLayers);
const printButtonIconSrc = getIndorImageSrc(IndorImages.Print);

export default function ContentHeaderCardWidgets({ cardType }: any) {
    const navigate = useNavigate()
    const { searchLineIsShown, highContrastModeIsEnabled } = useAppSelector(state => state.contentHeader)
    const cardIsLoadingState = useAppSelector(state => state.tableObject.tableObjectIsLoadingState)
    const { loadingCoords, loadingStructure, loadingData } = cardIsLoadingState
    const contentHeaderWidgetIsLoading = loadingCoords || loadingStructure || loadingData

    const widgetsConfigArray = [
        {
            loading: contentHeaderWidgetIsLoading,
            active: searchLineIsShown,
            name: "Настройки карты",
            imageSrc: mapSettingsButtonIconSrc,
            onClick: () => controlMapSettingsButton(navigate)
        },
        {
            loading: contentHeaderWidgetIsLoading,
            active: highContrastModeIsEnabled,
            name: "Режим высокой контрастности",
            imageSrc: highContrastModeButtonIconSrc,
            onClick: controlHighContrastModeButton
        },
        {
            loading: contentHeaderWidgetIsLoading,
            name: "Распечатать",
            imageSrc: printButtonIconSrc,
            onClick: controlPrintButton
        },
    ]

    return (
        <>
            {widgetsConfigArray.map((contentHeaderMapWidget: any, idx: number) => {
                const { visible, name, active, imageSrc, onClick, loading } = contentHeaderMapWidget ?? {}
                const buttonIsVisible = ('visible' in contentHeaderMapWidget && visible) || !('visible' in contentHeaderMapWidget)
                if (buttonIsVisible) {
                    return (
                        <ContentHeaderButton
                            key={name}
                            active={active}
                            imageSrc={imageSrc}
                            name={name}
                            onClick={onClick}
                            isLoading={loading}
                        />
                    )
                }
            })}
        </>
    )
}